export const initialDataState = {
  sort: [
    {
      field: "code",
      dir: "asc",
    },
  ],
};
export const DEFAULT_MULTIPLE = { value: 0, shape: "" };

export const DEFAULT_CURRENCY = {
  ...DEFAULT_MULTIPLE,
  name: "",
  shortName: "",
  symbol: "",
  type: "",
  exchangeRate: 0,
  multiples: [],
};

export const CURRENCY_TYPES = [
  {
    id: "Local",
    text: "Local",
  },
  {
    id: "Foreign Exchange",
    text: "Foreign Exchange",
  },
];

export const CURRENCY_SHAPES = [
  {
    id: "Coins",
    text: "Coins",
  },
  {
    id: "Notes",
    text: "Notes",
  },
];
